import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api, { getApiErrorMessage } from '../api';

const dateRu = (value) => (value ? new Date(value).toLocaleDateString('ru-RU') : '');

/** Согласие на информационную рассылку: видно, когда дано, и можно в любой момент отозвать или дать снова. */
function NewsletterCard({ profile, onChanged }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const subscribed = Boolean(profile.agreed_to_newsletter);

    const toggle = async () => {
        setBusy(true);
        setError('');
        try {
            await api.put('/users/me/newsletter', { subscribed: !subscribed });
            await onChanged?.();
        } catch (err) {
            setError(getApiErrorMessage(err, 'Не удалось сохранить'));
        } finally {
            setBusy(false);
        }
    };

    let status;
    if (subscribed) {
        status = profile.newsletter_consent_at ? `Согласие дано ${dateRu(profile.newsletter_consent_at)}.` : 'Согласие дано при регистрации.';
    } else if (profile.newsletter_revoked_at) {
        status = `Вы отказались от рассылки ${dateRu(profile.newsletter_revoked_at)}.`;
    } else {
        status = 'Вы не подписаны.';
    }

    return (
        <div className="profile-card">
            <h2 className="profile-section-title">Рассылка</h2>
            <label className="newsletter-toggle">
                <input type="checkbox" checked={subscribed} onChange={toggle} disabled={busy} />
                <span>
                    Получать <Link to="/mailing-consent" target="_blank">информационную рассылку</Link> СВОД: новости, скидки и промокоды
                </span>
            </label>
            <p className="newsletter-status">{status} Письма о безопасности аккаунта и отчёты по опросам приходят независимо от этой настройки.</p>
            {error && <div className="profile-feedback profile-feedback--error">{error}</div>}
        </div>
    );
}

export default NewsletterCard;
